import { useSelector } from "react-redux";
import { Box, CircularProgress, Typography } from "@mui/material";
import { globalStyle } from "../../global/Utils";
import BuyerStatusJob from "./BuyerStatusJob";

// One block per group of tools. A new tool is a new component in its group; a
// new group is another <Section>.
const Section = ({ title, hint, children }) => (
  <Box
    component="section"
    sx={{
      mb: 3,
      p: { xs: 2, sm: 3 },
      borderRadius: 2,
      backgroundColor: "#fff",
      border: `1px solid ${globalStyle.curveLightColor}`,
    }}
  >
    <Box
      component="h2"
      sx={{
        m: 0,
        fontFamily: globalStyle.fontFamilyHeading,
        fontWeight: 700,
        fontSize: 20,
        color: globalStyle.curveDarkColor,
      }}
    >
      {title}
    </Box>
    {hint && (
      <Box
        component="p"
        sx={{
          mt: 0.5,
          mb: 2,
          fontFamily: globalStyle.fontFamilyParagraph,
          fontSize: 14,
          color: "#666",
        }}
      >
        {hint}
      </Box>
    )}
    {children}
  </Box>
);

// Program Settings: tools for administrators only. Nothing below the role
// check may render for anyone else - the server answers their requests with a
// 401, and the app treats any 401 as "logged out".
const ProgramSettings = () => {
  const userDetails = useSelector((state) => state?.HeaderReducer?.userDetails);

  if (!userDetails) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <CircularProgress />
      </div>
    );
  }

  if (userDetails.role !== "admin") {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <Typography className="text-slate-500">
          Access denied. This page is for administrators only.
        </Typography>
      </div>
    );
  }

  return (
    <Box className="p-4">
      <Box sx={{ mb: 2 }}>
        <Box
          component="h1"
          sx={{
            fontFamily: globalStyle.fontFamilyHeading,
            fontWeight: 700,
            color: globalStyle.bgColorBlue,
            fontSize: {
              xs: globalStyle.headingFontSizeSmall, // mobile
              sm: globalStyle.headingFontSize, // tablet+
            },
            lineHeight: 1.2,
          }}
        >
          Program Settings
        </Box>
        <Box
          component="p"
          sx={{
            mt: 0.5,
            fontFamily: globalStyle.fontFamilyParagraph,
            fontSize: {
              xs: 12,
              sm: 14,
            },
            color: "#666",
          }}
        >
          Tools for administrators
        </Box>
      </Box>

      <Section
        title="Cron Jobs"
        hint="Jobs that go through the data of every account. Each runs on the server when you start it."
      >
        <BuyerStatusJob />
      </Section>
    </Box>
  );
};

export default ProgramSettings;
